import { cn } from "@omni/utils/styles";

import { FormGroup } from "@/components/Form/Base/formGroup.component";
import { Input } from "@/components/Form/Base/input.component";
import { Label } from "@/components/Form/Base/label.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useCallToActionsContext } from "@/utils/callToActions/callToActions.provider";
import { CallToActionTypes } from "@/utils/enums";
import { underScoreToCamelCase } from "@/utils/textUtils";

type Props = {
    type: CallToActionTypes;
    actualQuantity: string;
    sku?: string;
};

const ChangeQuantityCTAVisual = ({ type, actualQuantity, sku }: Props) => {
    const { t } = useGranite();
    const { currentType, resetCurrentType } = useCallToActionsContext();

    const handleOnClick = () => resetCurrentType({ type, sku });

    return (
        <FormGroup
            toggle={true}
            className={cn("tw:mt-4")}
        >
            <Label>
                <Input
                    type={"radio"}
                    name={type}
                    checked={type === currentType?.type}
                    onClick={handleOnClick}
                />
                {t(
                    `general.cta.${underScoreToCamelCase(type)}.option`,
                    actualQuantity
                )}
            </Label>
        </FormGroup>
    );
};

export default ChangeQuantityCTAVisual;
